// extracted by mini-css-extract-plugin
export default {"wrapper":"dzA5W4b078","capture":"_7+tak2IdP3","capture-wrapper":"Ny3Gqcp-J9","captureWrapper":"Ny3Gqcp-J9","video":"_52gbCryO5V","msg":"_2W-D-5mFOO"};